import React, { useState } from 'react'
import Budgets from './Budgets'
import BudgetsApi from '../../../api/Budgets'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalShow from '../../../elements/Hooks/useModalShow'
import { BUDGET_TYPE_INTERNAL } from '../../../components/Common/Budgets/BudgetCont'
import useTitle from '../../../elements/Hooks/useTitle'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

const api = new BudgetsApi()

function BudgetsCont(props) {
  const { option } = props
  const { fetch, fetching, list: cached } = useFetchList(() => api.list(option))
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  const [budget, setBudget] = useState()
  const { visible, onShow, onCancel } = useModalShow()
  useTitle('Budgets')
  return (
    <Budgets
      {...{
        option,
        visible,
        onShow,
        onCancel,
        fetch,
        fetching,
        list,
        budget,
        setBudget,
        company,
        onChangeCompany,
      }}
    />
  )
}

BudgetsCont.propTypes = {}
BudgetsCont.defaultProps = { option: BUDGET_TYPE_INTERNAL }

export default BudgetsCont
